import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class ReporteBalanceKRService {
  public api_url: string;
  public modulo_url: string;
  public service_url: string;
  constructor(private http: Http, private authService: AutenticacionService, private constantService: ConstantsService) {
    this.api_url = this.constantService.apiURL;
    this.modulo_url = '/reportes/reporte-balance-kr';
    this.service_url = this.api_url + this.modulo_url;
  }

  getConceptos(){
    return this.http.get(this.service_url + '/conceptos?select=true', this.authService.getAuthHeaders());
  }

  getReporte(concepto, fechaInicial, fechaFinal) {
    if (!concepto || !concepto.idConceptos) {
      return this.http.get(this.service_url + '?fechaInicial=' + fechaInicial + '&fechaFinal=' + fechaFinal + '&idConceptos=', this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?fechaInicial=' + fechaInicial + '&fechaFinal=' + fechaFinal+ '&idConceptos=' + concepto.idConceptos, this.authService.getAuthHeaders());
  }

  getMovimientos(idConceptos, fechaInicial, fechaFinal) {
    return this.http.get(this.service_url + '/movimientos?filter=||' + idConceptos +'|||'+fechaInicial+'|'+fechaFinal, this.authService.getAuthHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/reporte-balance-kr.service.ts